import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, useRouteError } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import ScreenLanding from "./components/ScreenLanding";
import ScreenReport, { reportLoader } from "./components/ScreenReport";
import awsConfig from "./aws-exports.js";
import {Amplify} from "aws-amplify";

Amplify.configure(awsConfig);

const ErrorBoundary = () => {
    let error = useRouteError();
    console.log(error);
    return <div>The page you seek does not exist!</div>;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
    {
        path: "/",
        element: <ScreenLanding />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: ":incidentId",
                element: <ScreenReport />,
                loader: reportLoader,
            },
        ],
    },
]);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
